// Footer.jsx atau Footer.tsx
import { Layout, Row, Col, Button } from "antd";
import {
  FacebookFilled,
  TwitterOutlined,
  LinkedinOutlined,
  YoutubeOutlined,
  SlackOutlined,
  InstagramFilled,
} from "@ant-design/icons";
import { useContext } from "react";
import { LanguageContext } from "../context/Language.contex";
import Logo from "../component/Logo/Logo";
import { useNavigate } from "react-router-dom";

const { Footer: AntFooter } = Layout;

export const Footers = () => {
  const navigate = useNavigate();

  const { language } = useContext(LanguageContext);

  return (
    <AntFooter
      style={{
        backgroundColor: "#1d1f2f",
        color: "#ffffff",
        padding: "40px 60px",
      }}
    >
      <Row gutter={[32, 32]}>
        {/* Kolom 1 - Logo dan Theme */}
        <Col xs={24} md={8}>
          <Logo />
          {/* Logo */}
          <h3 style={{ fontSize: 18, fontWeight: "bold" }}>
            PT.Langgeng Buana Jaya.
          </h3>
        </Col>

        {/* Kolom 2 - Menu Navigasi */}
        <Col xs={24} md={8}>
          <h3 style={{ fontSize: 16, color: "#ffffff", marginBottom: 12 }}>
            {language[14]}
          </h3>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              color: "#cccccc",
              lineHeight: 2,
            }}
          >
            <li>
              <a href="/event" style={{ color: "#cccccc" }}>
                {language[15]}
              </a>
            </li>
            <li>
              <a href="/career" style={{ color: "#cccccc" }}>
                {language[16]}
              </a>
            </li>
            <li>
              <a href="/about" style={{ color: "#cccccc" }}>
                {language[17]}
              </a>
            </li>
          </ul>
        </Col>

        {/* Kolom 3 - Tentang & Sosial Media */}
        <Col xs={24} md={8}>
          <h3 style={{ fontSize: 16, color: "#ffffff", marginBottom: 12 }}>
            {language[18]}
          </h3>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              color: "#cccccc",
              lineHeight: 2,
            }}
          >
            <FacebookFilled style={{ fontSize: 20, color: "#ffffff" }} />
            <InstagramFilled style={{ fontSize: 20, color: "#ffffff" }} />
            {/* <li>
              <a href="#" style={{ color: "#cccccc" }}>
                Documentation
              </a>
            </li>
            <li>
              <a href="#" style={{ color: "#cccccc" }}>
                Contact Us
              </a>
            </li> */}
          </ul>

          {/* <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
            <TwitterOutlined style={{ fontSize: 20, color: "#ffffff" }} />
            <FacebookFilled style={{ fontSize: 20, color: "#ffffff" }} />
            <LinkedinOutlined style={{ fontSize: 20, color: "#ffffff" }} />
            <YoutubeOutlined style={{ fontSize: 20, color: "#ffffff" }} />
            <SlackOutlined style={{ fontSize: 20, color: "#ffffff" }} />
          </div> */}

          {/* <Button
            type="primary"
            shape="round"
            size="large"
            style={{
              backgroundColor: '#3e32e7',
              marginTop: 24,
              border: 'none',
              padding: '0 24px',
            }}
          >
            Subscribe Newsletter
          </Button> */}
        </Col>
      </Row>

      <div
        style={{
          marginTop: 40,
          textAlign: "center",
          color: "#999",
          fontSize: 12,
        }}
      >
        PT.LANGGENG BUANA JAYA
        <span style={{ color: "#fff", fontWeight: 500 }}>
          Developed by LBJ 2025
        </span>
      </div>
    </AntFooter>
  );
};
